module.exports = __webpack_public_path__ + "static/media/base_impact_eco.06f9f605.png";